// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"85":"a503c537","220":"9b5433a1","524":"009feaa1","787":"0407fcfe"}[chunkId] + ".chunk.js";
};